import { ScheduleableFoodType } from "model/food/types"
import {
  ICreateSchedulePayload,
  IEdamaForSchedulePayload,
  IMyFoodForSchedulePayload,
  IOpenFoodFactForSchedulePayload,
  IScheduleConfigPayload,
} from "model/food/types/schedulePayloads.types"
import { IEdamaFood } from "model/food/types/edama.types"
import { getNutritionPayload } from "./getBaseMealPayloadFromFood"
import { getImagePayload } from "./getImagePayload"
import { IMyFood } from "model/food/types/myfood.types"
import { LogMealType } from "model/food/types/base.types"
import { IOpenFoodFactFood } from "model/food/types/openFoodFact.types"

const getEdamaMealSchedulePayloadFromFood = ({
  food,
  configPayload,
  mealType,
}: {
  food: IEdamaFood
  configPayload: IScheduleConfigPayload
  mealType?: LogMealType
}) => {
  const payload: IEdamaForSchedulePayload = {
    ...getNutritionPayload(food),
    ...getImagePayload(food),
    ...configPayload,
    mealName: food.name,
    portion: food.portion,
    unit: food.unit,
    foodId: food.id!,
    units: food.units,
    source: "EDAMAM",
    brand: food.brand,
    mealType,
  }

  return payload
}

const getMyMealSchedulePayloadFromFood = ({
  food,
  configPayload,
  mealType,
}: {
  food: IMyFood
  configPayload: IScheduleConfigPayload
  mealType?: LogMealType
}): IMyFoodForSchedulePayload => {
  const payload: IMyFoodForSchedulePayload = {
    ...getNutritionPayload(food),
    ...getImagePayload(food),
    ...configPayload,
    mealName: food.name,
    portion: food.portion,
    unit: food.unit,
    foodId: food.id!,
    source: "MY_FOOD",
    ingredients: food.ingredients,
    mealType,
  }
  return payload
}

const getOpenFoodFactMealSchedulePayloadFromFood = ({
  food,
  mealType,
  configPayload,
}: {
  food: IOpenFoodFactFood
  configPayload: IScheduleConfigPayload
  mealType?: LogMealType
}): IOpenFoodFactForSchedulePayload => {
  const payload: IOpenFoodFactForSchedulePayload = {
    ...getNutritionPayload(food),
    ...getImagePayload(food),
    ...configPayload,
    mealName: food.name,
    portion: food.portion,
    unit: food.unit,
    foodId: food.id!,
    source: "OPEN_FOOD_FACTS",
    brand: food.brand,
    mealType,
  }

  return payload
}

const getSchedulePayloadFromFood = ({
  food,
  configPayload,
  mealType,
}: {
  food: ScheduleableFoodType
  configPayload: IScheduleConfigPayload
  mealType?: LogMealType
}): ICreateSchedulePayload | undefined => {
  switch (food.source) {
    case "EDAMAM":
      return getEdamaMealSchedulePayloadFromFood({
        food,
        configPayload,
        mealType,
      })

    case "MY_FOOD":
      return getMyMealSchedulePayloadFromFood({
        food,
        configPayload,
        mealType,
      })

    case "OPEN_FOOD_FACTS":
      return getOpenFoodFactMealSchedulePayloadFromFood({
        food,
        configPayload,
        mealType,
      })

    default:
      break
  }
}

export default getSchedulePayloadFromFood
